import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=bdad7a40&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdad7a40')) {
      api.createRecord('bdad7a40', component.options)
    } else {
      api.reload('bdad7a40', component.options)
    }
    module.hot.accept("./Person.vue?vue&type=template&id=bdad7a40&", function () {
      api.rerender('bdad7a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/items/Person.vue"
export default component.exports